export const PasswordHintSuccessIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M9.50749 17.235L4.58057 12.3081L5.13632 11.7715L9.50749 16.1427L18.8575 6.77344L19.4133 7.32921L9.50749 17.235Z" fill="#00F054" />
    </svg>
  )
}
